import { GLOBAL_EXPORT_BUTTON_ENABLED } from 'src/constants/user';

export const INITIAL_FILTERS_STATE = {
  email: '',
  sort_by: 'commission_due',
  order: 'desc',
};

export const EXPORT_BUTTON_ENABLED = [
  ...GLOBAL_EXPORT_BUTTON_ENABLED,
  'mila.staneva@redtrack.io',
  'svyatoslav.svyatsky@redtrack.io',
  'olga@redtrack.io',
  'carmen.buzatu@redtrack.io',
];

export const REFERRALS_FIELDS = [
  {
    type: 'textField',
    label: 'Email',
    name: 'email',
    placeholder: 'Search by email',
    className: 'main',
  },
];
